import type { TestListItem } from "../api/schemas";

export type TestsListRowProps = {
  test: TestListItem;
  active: boolean;
  onClick: () => void;
};

function labelFor(t: TestListItem): string {
  if (t.name && t.name.trim().length > 0) return t.name;
  if (t.source_event) return t.source_event;
  return t.track_code;
}

function relativeTime(iso: string, nowMs: number = Date.now()): string {
  const then = Date.parse(iso);
  if (!Number.isFinite(then)) return "";
  const deltaSec = Math.max(0, (nowMs - then) / 1000);
  if (deltaSec < 60) return "just now";
  if (deltaSec < 3600) return `${Math.floor(deltaSec / 60)}m ago`;
  if (deltaSec < 86400) return `${Math.floor(deltaSec / 3600)}h ago`;
  return `${Math.floor(deltaSec / 86400)}d ago`;
}

export function TestsListRow({ test, active, onClick }: TestsListRowProps) {
  return (
    <button
      type="button"
      data-testid={`tests-list-row-${test.id}`}
      data-active={active}
      onClick={onClick}
      className="tests-list-row"
    >
      <div className="row-line-1">
        <span className="row-id">#{test.id}</span>
        <span className="row-label">{labelFor(test)}</span>
      </div>
      <div className="row-line-2 muted">
        {test.status} · {relativeTime(test.updated_at)}
        {test.active_runs > 0 && (
          <span
            className="row-activity-badge"
            data-testid={`row-activity-${test.id}`}
            title={`${test.active_runs} run${test.active_runs === 1 ? "" : "s"} in flight`}
          >
            <span className="row-activity-dot" aria-hidden="true" />
            {test.active_runs} running
          </span>
        )}
        {test.ar_active && (
          <span
            className="row-activity-badge row-activity-badge--ar"
            data-testid={`row-ar-${test.id}`}
            title="AutoResearch session live on this study"
          >
            <span className="row-activity-dot" aria-hidden="true" />
            AR
          </span>
        )}
      </div>
    </button>
  );
}
